export var ID3;
(function (ID3) {
    ID3["NAME"] = "pplus.id3";
    ID3["BROADCAST_END"] = "broadcast_end";
    ID3["GAME_END"] = "game_end";
    ID3["LINEAR_AD_TRACKING"] = "com.paramount.vtg";
})(ID3 || (ID3 = {}));
